// extracted by mini-css-extract-plugin
export default {"mainLayout":"mainLayout_mainLayout__iC55s","MainBody":"mainLayout_MainBody__mkDSI"};